import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { ContentStyle, DataGridListStyle } from "../../Theme";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import { v4 as uuid } from "uuid";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useState } from "react";
import MyBriefCaseDetails from "./MyBriefCaseDetails";
import NoRecords from "../../components/NoRecords";
import { BriefCaseCount } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";
import ErrorOverlay from "../../components/ErrorOverlay";

export default function MyBriefCase() {
  const [showFlow, setShowFlow] = useState(false);
  const [Type, setType] = useState("");

  const doctorId: any = localStorage.getItem("doctorId");
  const params = {
    doctorId: doctorId,
  };
  const { data, loading, error } = useFetch(params, BriefCaseCount, []);

  const columns: GridColDef[] = [
    {
      field: "type",
      headerName: "Type",
      width: 120,
      cellClassName: "w40",
      headerClassName: "w40",
    },
    {
      field: "count",
      headerName: "Count",
      width: 80,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  setShowFlow(true);
                }}
              >
                <img
                  src={ShowPasswordIcon}
                  alt="Show/Hide Password"
                  loading="lazy"
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {" "}
          <Grid item xs={12}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              My BriefCase{" "}
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      Larger reports can be stored and viewed in My Briefcase
                      (when the user size is greater than 10 Nos.)
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>
          {showFlow ? (
            <>
              <MyBriefCaseDetails setShowFlow={setShowFlow} Type={Type} />
            </>
          ) : (
            <>
              <Grid item xs={12}>
                <DataGridListStyle>
                  <DataGrid
                    rows={data}
                    headerHeight={36}
                    sortingOrder={["desc", "asc"]}
                    columns={columns}
                    autoHeight
                    rowHeight={40}
                    disableSelectionOnClick
                    getRowId={() => uuid()}
                    loading={loading}
                    components={{
                      NoRowsOverlay: NoRecords,
                      NoResultsOverlay: NoRecords,
                      ErrorOverlay: ErrorOverlay,
                    }}
                    error={error || undefined}
                    rowsPerPageOptions={[10]}
                    hideFooter={true}
                    onRowClick={({ row }) => {
                      setType(row.type);
                      setShowFlow(true);
                    }}
                  />
                </DataGridListStyle>
              </Grid>
            </>
          )}
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
